import { IBaseAllergy } from '../../../interfaces';
import { BaseAllergyToMedicalHistoryMappingHandler } from '../../../mappings/allergy-to-medical-history';
import {
  D4WPatientAllergyOptions,
  ID4WAllergyOption,
  PatientAllergyOptionsSourceEntity,
} from '../../source/entities/patient-allergy-options';

export class D4WAllergyMappingHandler extends BaseAllergyToMedicalHistoryMappingHandler<
  D4WPatientAllergyOptions,
  PatientAllergyOptionsSourceEntity
> {
  override sourceEntity = new PatientAllergyOptionsSourceEntity();

  translateFn = (record: ID4WAllergyOption): IBaseAllergy => ({
    description: record.description,
    id: record.id,
  });
}
